import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { hasPermission } from "@/shared/utils/permissions";
import { RouteError } from "@/shared/components/RouteError";

export const Route = createFileRoute("/app/admin/kpis")({
  beforeLoad: ({ context }) => {
    if (!hasPermission(context.auth.user, "reporting.kpiOps.read")) {
      throw redirect({ to: "/app" });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  component: () => <Outlet />,
});
